import Lock from '@mui/icons-material/Lock';
import Public from '@mui/icons-material/Public';
import { boolean, BooleanSchema, object, string, StringSchema } from 'yup';
import { SHARE_TYPES } from 'shared/constants/share';

export enum ShareAccessType {
	public = 'public',
	password = 'password',
}

export const SHARE_BUTTON_DATA = {
	[ShareAccessType.password]: {
		Icon: Lock,
		title: 'Password Protected',
		description: 'Requires password to access',
	},
	[ShareAccessType.public]: {
		Icon: Public,
		title: 'Public Access',
		description: 'Anyone with the link can view',
	},
} as const;

export const SHARE_LINK_SCHEMA = object().shape({
	documentId: string().default(''),
	type: string().default(''),
	accessType: string().required('Required').default(ShareAccessType.password).min(1),
	password: string().default('')
		.when('accessType', {
			is: ShareAccessType.password,
			then: (fieldSchema: StringSchema) => fieldSchema.required('1 char min').min(1),
		}),
	canEdit: boolean().default(false)
		.when('type', {
			is: SHARE_TYPES.project,
			then: (fieldSchema: BooleanSchema) => fieldSchema.required(),
		}),
	canAddFiles: boolean().default(false)
		.when('type', {
			is: SHARE_TYPES.project,
			then: (fieldSchema: BooleanSchema) => fieldSchema.required(),
		}),
	canRemoveFiles: boolean().default(false)
		.when('type', {
			is: SHARE_TYPES.project,
			then: (fieldSchema: BooleanSchema) => fieldSchema.required(),
		}),
	expirationEnabled: boolean().default(false),
	expirationDate: string().default(''),
});
